import {Object3D} from 'three'
import {BaseLoader} from './BaseLoader'

/**
 * Базовый класс для загрузчиков, использующих числовые ключи для обратной совместимости
 * Устраняет дублирование логики работы с числовыми коллекциями
 */
export abstract class BaseNumericLoader extends BaseLoader {
  /**
   * Числовая коллекция объектов для обратной совместимости
   * Синхронизируется с основной objectsMap
   */
  protected readonly numericObjects: Record<number, Object3D> = {}

  /**
   * Очистка числовой коллекции после очистки основной
   */
  protected onAfterClear(): void {
    for (const key in this.numericObjects) {
      delete this.numericObjects[key]
    }
  }

  /**
   * Получение объектов по числовому ключу (для обратной совместимости)
   * Возвращает readonly Record для защиты от изменений извне
   */
  protected getNumericObjects(): Readonly<Record<number, Object3D>> {
    return Object.freeze({...this.numericObjects}) as Readonly<
      Record<number, Object3D>
    >
  }

  /**
   * Добавление объекта в числовую коллекцию
   * @param numericId Числовой ID
   * @param object Объект для добавления
   */
  protected addToNumericCollection(
    numericId: number,
    object: Object3D
  ): void {
    this.numericObjects[numericId] = object
  }

  /**
   * Удаление объекта из числовой коллекции
   * @param numericId Числовой ID
   */
  protected removeFromNumericCollection(numericId: number): void {
    delete this.numericObjects[numericId]
  }
}
